var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiconIpphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1431 7.42857H2.85742V24.5714H29.1431V7.42857Z",
    stroke: "#A1A1A1",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.14258 5.14286L5.14258 26.8571H13.1426L13.1426 5.14286H5.14258Z",
    fill: "#F5F5F5",
    stroke: "#A1A1A1",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9994 14.2857L26.2852 14.2857V9.71429H15.9994V14.2857Z",
    fill: "#73B8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.142 17.1429H23.4277",
    stroke: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.142 18.8571H23.4277",
    stroke: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.142 20.5714H23.4277",
    stroke: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2866 17.1429H20.5723",
    stroke: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2866 18.8571H20.5723",
    stroke: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2866 20.5714H20.5723",
    stroke: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4291 17.1429H17.7148",
    stroke: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4291 18.8571H17.7148",
    stroke: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4291 20.5714H17.7148",
    stroke: "#A1A1A1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiconIpphone);
export default __webpack_public_path__ + "static/media/dicon_ipphone.eea96532ef0e29c9bbdd1f8df84a8ce2.svg";
export { ForwardRef as ReactComponent };